import {
  CUSTOM_FORM_SET_LOADING,
  CUSTOM_FORM_SET_LOADING_DONE,
  SET_CUSTOM_FORM_DATA,
  SET_CUSTOM_FORM_ERROR,
} from '../constants';

const INITIAL_STATE = {};

export const customFormReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOM_FORM_SET_LOADING_DONE:
    case CUSTOM_FORM_SET_LOADING:
      return {
        ...state,
        [action.payload]: customFormDataReducer(state[action.payload], action),
      };

    case SET_CUSTOM_FORM_DATA:
    case SET_CUSTOM_FORM_ERROR:
      return {
        ...state,
        [action.payload.formId]: customFormDataReducer(
          state[action.payload.formId],
          action
        ),
      };

    default:
      return state;
  }
};

const DOC_INITIAL_STATE = {
  isLoading: false,
  data: null,
  error: '',
};

const customFormDataReducer = (state = DOC_INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOM_FORM_SET_LOADING:
      return { ...DOC_INITIAL_STATE, isLoading: true };

    case CUSTOM_FORM_SET_LOADING_DONE:
      return { ...DOC_INITIAL_STATE, isLoading: false };

    case SET_CUSTOM_FORM_DATA:
      return { ...DOC_INITIAL_STATE, data: action.payload.data };

    case SET_CUSTOM_FORM_ERROR:
      return { ...DOC_INITIAL_STATE, error: action.payload.error };

    default:
      return state;
  }
};
